import HowToEarnDrawTicketsBadge from "../components/howItWorks/HowToEarnDrawTicketsBadge";

export const HOW_TO = [
  {
    header: "Enter and Earn Draw Tickets",
    description: "Enter any competition via the paid or postal entry route to instantly earn draw tickets.",
    image: "/assets/images/christmas-raffle/modal-icon1.png",
    ExtraComponent: HowToEarnDrawTicketsBadge,
  },
  {
    header: "Win Daily Prizes",
    description:
      "Your tickets are automatically entered into that day's daily draw. Check back every night at 6 PM to see if you've won cash, game credit, discounts or other competitions tickets.",
    // description:
    //   "Your tickets are automatically entered into that day's daily draw. Check back every night at 9:30 PM to see if you've won cash, game credit, discounts or other competitions tickets.",
    image: "/assets/images/christmas-raffle/modal-icon2.png",
  },
  {
    header: "Enter The Grand Finale",
    description:
      "On October 31st, every ticket you've collected enters the Grand Finale. 12,000 prizes will be won, including a Toyota GR Yaris worth £30,000 (or £21,000 cash), 5x £2,000 cash prizes, and thousands of Dream Home tickets.",
    // description:
    //   "On March 2nd, every ticket you've collected enters the Grand Finale. 10,000 prizes will be won, including a BMW M4 worth £51,000 (or £32,000 cash), 5x £2,000 cash prizes, and thousands of Dream Home tickets.",
    image: "/assets/images/christmas-raffle/modal-icon3.png",
  },
];
